<script>
  import { Button, Link, phonePrettify, phonePurify, store, imgSrc } from '$client';
  const year = new Date().getFullYear();
  const { city } = store;
  export let data;
</script>

<footer class="container" itemscope itemtype="http://schema.org/Organization">
  <div id="footer-useful">
    <div id="footer-action-container">
      <meta itemprop="name" content="uberi" />
      <meta itemprop="alternateName" content="убери" />
      <meta itemprop="url" content="https://uberi.pro" />
      <Link href="/" attributes={{ id: 'footer-logo', class: 'push-button' }}>
        <img
          loading="lazy"
          height="37"
          width="112"
          itemprop="logo"
          src={imgSrc(data.img.data.attributes.url)}
          alt={data.img.data.attributes.alternativeText} />
      </Link>

      <address id="footer-tablet-contacts" class="footer-tablet">
        <div class="footer-social">
          {#each $city.socials as { img, href }}
            <a
              class="push-button"
              target="_blank"
              rel="nofollow"
              {href}
              style="background-image: url({imgSrc(img.data.attributes.url)})"
              aria-label={img.data.attributes.alternativeText}>
            </a>
          {/each}
        </div>

        <a itemprop="email" class="color-button" rel="nofollow" href="mailto:{$city.email}">{$city.email}</a>
      </address>

      <a
        class="footer-tablet color-button"
        id="footer-tablet-phone"
        rel="nofollow"
        itemprop="telephone"
        href="tel:{phonePurify($city.phone)}">{phonePrettify($city.phone)}</a>

      <div class="footer-action footer-tablet-always">
        <Button title={data.button[0].header} action={data.button[0].href ?? data.button[0].modal} />
        <a itemprop="telephone" class="footer-mobile color-button" rel="nofollow" href="tel:{phonePurify($city.phone)}"
          >{phonePrettify($city.phone)}</a>
      </div>
    </div>

    <address id="footer-contacts" class="footer-mobile">
      <div class="footer-social">
        {#each $city.socials as { img, href }}
          <a
            class="push-button"
            target="_blank"
            rel="nofollow"
            {href}
            style="background-image: url({imgSrc(img.data.attributes.url)})"
            aria-label={img.data.attributes.alternativeText}>
          </a>
        {/each}
      </div>

      <a itemprop="email" class="color-button" rel="nofollow" href="mailto:{$city.email}">{$city.email}</a>
    </address>

    <div id="footer-navigation">
      {#each data.links as link}
        <nav>
          <h3>{link.header}</h3>
          <ul>
            {#each link.block.data.attributes.links as innerLink}
              <li>
                <Link attributes={{ class: 'color-button' }} href={innerLink.href}>{innerLink.header}</Link>
              </li>
            {/each}
          </ul>
        </nav>
      {/each}
    </div>

    <div class="footer-action footer-desktop">
      <Button title={data.button[0].header} action={data.button[0].href ?? data.button[0].modal} />
      <a itemprop="telephone" class="color-button" rel="nofollow" href="tel:{phonePurify($city.phone)}"
        >{phonePrettify($city.phone)}</a>
    </div>
  </div>

  <address id="footer-bottom">
    <div class="footer-desktop footer-social">
      {#each $city.socials as { href, img }}
        <a
          class="push-button"
          target="_blank"
          rel="nofollow"
          {href}
          style="background-image: url({imgSrc(img.data.attributes.url)})"
          aria-label={img.data.attributes.alternativeText}>
        </a>
      {/each}
    </div>

    <div>
      {$city.region} <br />
      <time itemprop="openingHours" datetime="Mo-Su 9:00-21:00">{$city.workTime}</time>
    </div>

    <div itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
      © <time itemprop="foundingDate" datetime="2018-01-01">2018</time>-<time datetime="{year}-01-01">{year}</time>,
      ООО «Мои Платежи» <br />
      <span itemprop="streetAddress addressLocality">{$city.office}</span>
    </div>

    <a itemprop="email" class="footer-desktop color-button" rel="nofollow" href="mailto:{$city.email}">{$city.email}</a>
  </address>
</footer>

<style lang="scss">
  footer {
    position: relative;
    z-index: 2;
    padding-top: 56px;
    padding-bottom: 56px;
    color: #fff;
    font-weight: normal;
    font-size: 14px;
    font-family: Roboto;
    line-height: 130%;
    background-color: #2c333c;

    :global(a) {
      color: #fff;
    }

    @media only screen and (max-width: 1199.98px) {
      padding-top: 30px;
      padding-bottom: 30px;
      font-size: 16px;
    }

    > div,
    > address {
      position: relative;
      display: inline-flex;
      gap: 40px;
      justify-content: space-between;
      width: 100%;
    }

    > address {
      padding-top: 56px;
      border-top: 1px solid rgb(255 255 255 / 40%);

      @media only screen and (max-width: 1199.98px) {
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-top: 40px;
      }
    }
  }

  #footer-useful {
    padding-bottom: 56px;

    @media only screen and (max-width: 1199.98px) {
      flex-direction: column;
      gap: 40px;
      align-items: center;
      justify-content: flex-start;
      justify-content: space-between;
      width: 100%;
      padding-bottom: 40px;

      > #footer-action-container {
        display: inline-flex;
        justify-content: space-between;
        width: 100%;
      }

      > #footer-contacts {
        flex-wrap: wrap;
        font-size: 16px;
      }

      > div,
      ul,
      > address {
        justify-content: space-between;
        width: 100%;
      }
    }
  }

  #footer-tablet-phone {
    margin-top: 11px;
    color: #f4f4f4;
    font-weight: 600;
    font-size: 16px;
    font-family: Vela Sans;
    line-height: 140%;
  }

  .footer-action {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-end;

    > a {
      color: #f4f4f4;
      font-weight: 600;
      font-size: 16px;
      font-family: Vela Sans;
      line-height: 140%;
    }

    @media only screen and (max-width: 1199.98px) {
      gap: 10px;
    }

    @media only screen and (max-width: 350.98px) {
      a {
        font-size: 14px;
      }
    }
  }

  .footer-social {
    display: inline-flex;
    gap: 24px;

    > a {
      position: relative;
      width: 24px;
      height: 24px;
      background-position: center center;
      background-size: cover;
    }
  }

  #footer-tablet-contacts {
    display: inline-flex;
    gap: 24px;
    margin-top: 10px;

    > a {
      margin-top: 2px;
      font-weight: 600;
      font-size: 16px;
      font-family: Vela Sans;
      line-height: 140%;
    }
  }

  :global(#footer-logo) {
    display: inline-flex;
    gap: 10px;
    justify-content: center;

    @media only screen and (max-width: 1199.98px) {
      :global(img) {
        width: auto;
        height: 40px;
      }
    }

    @media only screen and (max-width: 470.98px) {
      :global(img) {
        height: 35px;
        margin-top: 0;
      }
    }

    @media only screen and (max-width: 319.98px) {
      :global(img) {
        height: 30px;
      }
    }
  }

  #footer-navigation {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: center;

    > nav {
      display: flex;
      flex-direction: column;
      gap: 5px;

      > ul {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      h3 {
        font-weight: bold;
      }

      :global(a) {
        color: rgb(255 255 255 / 85%);
      }
    }
  }

  .footer-tablet-always {
    display: none !important;

    @media only screen and (max-width: 1199.98px) {
      display: flex !important;
    }
  }

  .footer-tablet {
    display: none !important;

    @media only screen and (max-width: 1199.98px) {
      display: flex !important;
    }

    @media only screen and (max-width: 991.98px) {
      display: none !important;
    }
  }

  .footer-desktop {
    @media only screen and (max-width: 1199.98px) {
      display: none !important;
    }
  }

  .footer-mobile {
    display: none !important;

    @media only screen and (max-width: 991.98px) {
      display: flex !important;
    }
  }
</style>
